export default {"src":"/_next/static/image/public/images/ic_menu_minus.855fa355fa27722c5ff93734560b88b7.svg","height":16,"width":16};